var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.803 1.222-2.496.624v1.872l-2.257.625v1.872l-2.304.576v2.065L4.49 9.864l6.818-1.729V2.23zm-.048.24 2.833.816-1.825.432-3.024-.768zM5.5 2.134l3.168.768v1.68L5.5 3.67zm-.05 1.777 2.976.864-1.92.432-3.025-.768zm-2.209.72 3.169.768v1.68l-3.169-.912zm.96 4.945L.938 8.664V7.127l3.264.768zm.096-1.92-3.12-.769 1.968-.48 2.977.864zm6.722.287-6.578 1.68V7.896l2.209-.48V5.447l2.256-.528V2.95l2.113-.528z",
    fill: "#13123A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.122 7.271-1.824.384-3.12-.768 2.016-.48zm4.465-4.993-1.824.432-3.025-.768 2.017-.48zm-2.16 2.497-1.92.432-3.025-.768L5.45 3.91z",
    fill: "#5A62C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.697.262h10.562v10.562H.697z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStairs);
export default __webpack_public_path__ + "static/media/ic_stairs.8874882dd5b6e0e7b0afa69f5c0485c6.svg";
export { ForwardRef as ReactComponent };